export const ENDPOINTS = {
  GET_ADMIN_COMMENTS:
    process.env.REACT_APP_BASE_URI + "/secure/api/v2/get_admin_bot_comments?",
  ADD_ADMIN_COMMENT:
    process.env.REACT_APP_BASE_URI + "/secure/api/v2/add_admin_bot_comment",
  DOTGO_ADMIN_FORWARD_BOT:
    process.env.REACT_APP_BASE_URI +
    "/secure/api/v2/forward_bot_verification_by_dotgo",
  GET_ADMIN_AGGREGATOR_COMMENTS:
    process.env.REACT_APP_BASE_URI +
    "/secure/api/v2/get_admin_aggregator_comments?",
  ADD_ADMIN_AGGREGATOR_COMMENT:
    process.env.REACT_APP_BASE_URI +
    "/secure/api/v2/add_admin_aggregator_comment",
  GET_TEMPLATE_COMMENTS:
    process.env.REACT_APP_BASE_URI +
    "/secure/api/v2/get_admin_template_comments?",
  ADD_TEMPLATE_COMMENT:
    process.env.REACT_APP_BASE_URI +
    "/secure/api/v2/add_admin_template_comment",
  GET_ADMIN_BRANDS_COMMENTS:
    process.env.REACT_APP_BASE_URI + "/secure/api/v2/get_admin_brand_comments?",
  ADD_ADMIN_BRANDS_COMMENT:
    process.env.REACT_APP_BASE_URI + "/secure/api/v2/add_admin_brand_comment",
  VI_ADMIN_SUMMARY:
    process.env.REACT_APP_BASE_URI + "/secure/api/v2/get_carrier_request_count",
  VI_CARRIER_ADMIN_SUMMARY:
    process.env.REACT_APP_BASE_URI + "/secure/api/v3/get_carrier_revenue",
  VI_CARRIER_ADMIN_EXCEL_REPORT:
    process.env.REACT_APP_BASE_URI +
    "/secure/api/v3/download_excel_report_for_carrier_billing_dashboard",
  VI_CARRIER_ADMIN_PDF_REPORT:
    process.env.REACT_APP_BASE_URI +
    "/secure/api/v3/download_pdf_report_for_carrier_billing_dashboard",
  VI_ADMIN_GET_LEADS_TABLE_DATA: process.env.REACT_APP_BASE_URI + "/secure/tabularViewForLeadReport",
  VI_ADMIN_GET_LEADS_FILTER_DATA: process.env.REACT_APP_BASE_URI + "/secure/getFilterDataForLeadReport",  
  VI_ADMIN_GET_LEADS_EXCEL_REPORT: process.env.REACT_APP_BASE_URI + "/secure/getLeadExcelReport",  
  VI_ADMIN_GET_LEAD_REPORT_START_DATE: process.env.REACT_APP_BASE_URI + "/secure/getLeadReportStartDate",  
};
